import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full table-auto rounded-lg overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-blue-500 text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-12 py-2" }),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "flex-1 px-4" }, "LP1"),
        /*#__PURE__*/_createElementVNode("div", { class: "flex-1 px-4" }, "LP2"),
        /*#__PURE__*/_createElementVNode("div", { class: "flex-1 px-4" }, "LP3"),
        /*#__PURE__*/_createElementVNode("div", { class: "flex-1 px-4" }, "LP4")
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "bg-blue-500 text-white py-2 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseWidget = _resolveComponent("CourseWidget")!
  const _component_gridCol = _resolveComponent("gridCol")!
  const _component_gridRow = _resolveComponent("gridRow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridData, (selectedCourses, courseYear) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: "border px-4 py-2",
          key: courseYear
        }, [
          _createElementVNode("td", _hoisted_3, _toDisplayString(courseYear), 1),
          _createVNode(_component_gridRow, {
            container: "",
            gutter: 12,
            class: "px-4 py-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCourses, (sublist) => {
                return (_openBlock(), _createBlock(_component_gridRow, { key: sublist }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sublist, (course) => {
                      return (_openBlock(), _createBlock(_component_gridCol, {
                        key: course,
                        lg: course.timePlans.duration * 3,
                        mdOffset: course.timePlans.offset * 3
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CourseWidget, { course: course }, null, 8, ["course"])
                        ]),
                        _: 2
                      }, 1032, ["lg", "mdOffset"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}